
import { getJustifyContentValue } from '../components/Elements/TABLE/tableUtils';

export const transformHtmlInLayoutList = (layoutList) => {

  return layoutList.map((layout) => {
    return [
      layout[0],
      layout[1].map((item) => {
        if ((item.data === "HTML" || item.data === "TABLE") & item.version === undefined) {
          return transformTable(item);
        } else if (item.data === "Row") {
          const transformedColumns = Object.keys(item.columns).reduce(
            (acc, column) => {
              acc[column] = item.columns[column].map((colItem) => {
                if (
                  (colItem.data === "HTML" || colItem.data === "TABLE") &
                  item.version === undefined
                ) {
                  return transformTable(colItem);
                } else if (colItem.data === "Row") {
                  const transformedNestedColumns = Object.keys(
                    colItem.columns
                  ).reduce((nestedAcc, nestedColumn) => {
                    nestedAcc[nestedColumn] = colItem.columns[nestedColumn].map(
                      (nestedColItem) => {
                        if (
                          (nestedColItem.data === "HTML" || nestedColItem.data === "TABLE") &
                          item.version === undefined
                        ) {
                          return transformTable(nestedColItem);
                        }
                        return nestedColItem;
                      }
                    );
                    return nestedAcc;
                  }, {});
                  return { ...colItem, columns: transformedNestedColumns };
                }
                return colItem;
              });
              return acc;
            },
            {}
          );
          return { ...item, columns: transformedColumns };
        }
        return item;
      }),
    ];
  });
};

export const transformHtmlInLayout = (layout) => {
  return layout.map((item) => {
    if ((item.data === "HTML" || item.data === "TABLE") & item.version === undefined) {
      return transformTable(item);
    } else if (item.data === "Row") {
      const transformedColumns = Object.keys(item.columns).reduce(
        (acc, column) => {
          acc[column] = item.columns[column].map((colItem) => {
            if ((colItem.data === "HTML" || colItem.data === "TABLE") & item.version === undefined) {
              return transformTable(colItem);
            } else if (colItem.data === "Row") {
              const transformedNestedColumns = Object.keys(
                colItem.columns
              ).reduce((nestedAcc, nestedColumn) => {
                nestedAcc[nestedColumn] = colItem.columns[nestedColumn].map(
                  (nestedColItem) => {
                    if (
                      (nestedColItem.data === "HTML" || nestedColItem.data === "TABLE") &
                      item.version === undefined
                    ) {
                      return transformTable(nestedColItem);
                    }
                    return nestedColItem;
                  }
                );
                return nestedAcc;
              }, {});
              return { ...colItem, columns: transformedNestedColumns };
            }
            return colItem;
          });
          return acc;
        },
        {}
      );
      return { ...item, columns: transformedColumns };
    }
    return item;
  });
};

const transformTable = (item) => {
  if (item.data === "HTML") {
    return transformHtml(item);
  } else if (item.data === "TABLE") {
    if (!item?.desktopStyle?.justifyContent) {
      const justifyContent = getJustifyContentValue(item.desktopStyle.content);
      const mobileJustifyContent = getJustifyContentValue(item.mobileStyle.content);
      return {
        ...item,
        desktopStyle: {
          ...item.desktopStyle,
          justifyContent: justifyContent,
        },
        mobileStyle: {
          ...item.mobileStyle,
          justifyContent: mobileJustifyContent,
        },
      };
    } else {
      return item;
    }
  }
}

// Helper function to add word-break style to all td elements in table HTML
const processTable = (tableHTML) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(tableHTML, 'text/html');

  // Select all <td> elements
  const tdElements = doc.querySelectorAll('td');

  // Add word-break: break-word to the style attribute of each <td>
  tdElements.forEach(td => {
    let currentStyle = td.getAttribute('style') || '';

    // Check for border-color with multiple values
    const borderColorRegex = /border-color:\s*([^;]+);/;
    const borderColorMatch = currentStyle.match(borderColorRegex);
    if (borderColorMatch) {
      const colors = borderColorMatch[1].trim().split(/\s+/);
      if (colors.length > 1) {
        // Replace border-color with #000000 if multiple colors are found
        currentStyle = currentStyle.replace(borderColorRegex, 'border-color: #000000;');
        // Replace or add border-width: 0.5px
        const borderWidthRegex = /border-width:\s*([^;]+);/;
        if (currentStyle.match(borderWidthRegex)) {
          currentStyle = currentStyle.replace(borderWidthRegex, 'border-width: 0.5px;');
        } else {
          currentStyle = currentStyle + 'border-width: 0.5px;';
        }
      }
    }

    // Add word-break: break-word
    const separator = currentStyle && !currentStyle.endsWith(';') ? ';' : '';
    td.setAttribute('style', `${currentStyle}${separator}word-break: break-word;`);
    td.setAttribute('data-mce-style', `${currentStyle}${separator}word-break: break-word;`);
  });

  // Serialize the table back to a string
  // Extract only the table element to avoid including <html><body> tags
  const tableElement = doc.querySelector('table');

  // Analyze table alignment and determine justifyContent
  const justifyContent = getJustifyContentValue(tableElement.outerHTML);

  return {
    content: tableElement.outerHTML || '',
    justifyContent: justifyContent,
  };
};


const transformHtml = (item) => {
  // Check if content is a string
  if (typeof item.content !== 'string') {
    return item;
  }

  // Parse the HTML content
  const parser = new DOMParser();
  const doc = parser.parseFromString(item.content, 'text/html');
  const body = doc.body;

  // Get direct child <table> elements
  const tables = Array.from(body.children).filter(child => child.tagName === 'TABLE');
  if (tables.length !== 1) {
    return item; // Must have exactly one table
  }
  const table = tables[0];
  // Check all other child nodes (siblings of the table)
  const siblings = Array.from(body.childNodes).filter(node => node !== table);
  // Helper function to determine if a node is ignorable (empty or whitespace only)
  function isIgnorable(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      return /^\s*$/.test(node.textContent);
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      return Array.from(node.childNodes).every(isIgnorable);
    } else {
      return true;
    }
  }

  // Validate that all siblings are ignorable
  if (siblings.every(isIgnorable)) {
    // Process table HTML to add word-break style to all td elements
    const { content, justifyContent } = processTable(table.outerHTML);
    return {
      data: "TABLE",
      name: item.name,
      label: item.label,
      id: item.id || null,
      isMirrored: true,
      edit: false,
      desktopStyle: {
        tableHeaderSticky: false,
        tableColumnSticky: false,
        fontFamily: "",
        marginTop: "0",
        marginBottom: "0",
        paddingLeft: "0",
        paddingRight: "0",
        width: "",
        height: "400",
        fullHeight: true,
        float: "left",
        content: content || initialTable,
        justifyContent: justifyContent || "flex-start",
      },
      mobileStyle: {
        tableHeaderSticky: false,
        tableColumnSticky: false,
        fontFamily: "",
        marginTop: "0",
        marginBottom: "0",
        paddingLeft: "0",
        paddingRight: "0",
        width: "",
        height: "400",
        fullHeight: true,
        float: "left",
        content: content || initialTable,
        justifyContent: justifyContent || "flex-start",
      }
    };
  } else {
    return item;
  }
}

const initialTable = `<table style="height: 400px; font-size: 12px; border-collapse: separate; border-spacing: 0px !important; background-color: rgb(255, 255, 255); border: 1px solid rgb(147, 155, 163);" border=".5px" width="100%" cellpadding="10px">
<tbody>
<tr style="height: 126.375px; background-color: rgb(69, 91, 115);">
<td style="width: 25%; border-width: 1px; text-align: center; vertical-align: middle; border-color: rgb(147, 155, 163);  height: 126.375px; padding: 10px; background-color: rgb(69, 91, 115);word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
  <td style="width: 25%; border-width: 1px; text-align: center; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; height: 126.375px; padding: 10px; background-color: rgb(69, 91, 115); word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
  <td style="width: 25%; border-width: 1px; text-align: center; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; height: 126.375px; padding: 10px; background-color: rgb(69, 91, 115); word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
  <td style="width: 25%; border-width: 1px; text-align: center; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; height: 126.375px; padding: 10px; background-color: rgb(69, 91, 115); word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
</tr>
<tr style="background-color: rgb(255, 255, 255); height: 67.9531px;">
<td style="width: 25%; border-width: 1px; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; text-align: left; height: 67.8906px; padding: 10px; background-color: rgb(255, 255, 255); word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
<td style="border-width: 1px; text-align: center; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; height: 67.8906px; width: 25%; padding: 10px; word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
<td style="border-width: 1px; text-align: center; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; height: 67.8906px; width: 25%; padding: 10px; word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
<td style="border-width: 1px; text-align: center; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; height: 67.8906px; width: 25%; padding: 10px; word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
</tr>
<tr style="background-color: rgb(255, 255, 255); height: 67.9531px;">
<td style="width: 25%; border-width: 1px; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; text-align: left; height: 67.8906px; padding: 10px; background-color: rgb(255, 255, 255); word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
<td style="border-width: 1px; text-align: center; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; height: 67.8906px; width: 25%; padding: 10px; word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
<td style="border-width: 1px; text-align: center; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; height: 67.8906px; width: 25%; padding: 10px; word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
<td style="border-width: 1px; text-align: center; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; height: 67.8906px; width: 25%; padding: 10px; word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
</tr>
<tr style="background-color: rgb(255, 255, 255); height: 67.9531px;">
<td style="width: 25%; border-width: 1px; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; text-align: left; height: 67.8906px; padding: 10px; background-color: rgb(255, 255, 255); word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
<td style="border-width: 1px; text-align: center; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; height: 67.8906px; width: 25%; padding: 10px; word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
<td style="border-width: 1px; text-align: center; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; height: 67.8906px; width: 25%; padding: 10px; word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
<td style="border-width: 1px; text-align: center; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; height: 67.8906px; width: 25%; padding: 10px; word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
</tr>
<tr style="background-color: rgb(255, 255, 255); height: 67.9531px;">
<td style="width: 25%; border-width: 1px; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; text-align: left; height: 67.9531px; padding: 10px; background-color: rgb(255, 255, 255); word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
<td style="border-width: 1px; text-align: center; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; height: 67.9531px; width: 25%; padding: 10px; word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
<td style="border-width: 1px; text-align: center; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; height: 67.9531px; width: 25%; padding: 10px; word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
<td style="border-width: 1px; text-align: center; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; height: 67.9531px; width: 25%; padding: 10px; word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
</tr>
</tbody>
</table>`